import React, { useState, useMemo } from "react";
import { Search, X } from "lucide-react";
import EmployeeRow from "./EmployeeRow";
import MonthGrid from "./MonthGrid";

const PlannerGrid = ({ employees, assignments, weekStart, monthStart, view, setView, onPrev, onNext }) => {
  // Week days array
  const weekDays = [...Array(7)].map((_, i) => {
    const d = new Date(weekStart);
    d.setDate(d.getDate() + i);
    return d;
  });

  // Roster search — filters the rows on the client, so it needs no refetch and
  // applies to the week grid and the month grid alike. Matches name and
  // designation, which are the only two things a row shows.
  const [query, setQuery] = useState("");
  const visibleEmployees = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return employees;
    return employees.filter((e) =>
      `${e.first_name || ""} ${e.last_name || ""} ${e.designation || ""}`
        .toLowerCase()
        .includes(q)
    );
  }, [employees, query]);

  return (
    <div className="planner-grid-wrapper">
      {/* Toolbar */}
      <div className="planner-toolbar">


        <div className="view-toggle">







        </div>
      </div>
      <div className="shift-header">
      <div className="shiftpl-wrap"> 

        <div className="btn-wrap month-disp">
          <button onClick={onPrev}>‹</button>
          <strong className="month-title">
             <span>{view === "week" ? "Week of" : "Month of"}</span>{" "}

            {view === "week"
              ?` ${weekStart.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}`
              : monthStart.toLocaleDateString("en-US", { month: "long", year: "numeric" })}
          </strong>
          <button onClick={onNext}>›</button>

         




</div>

    </div>

        {/* Roster search — sits between the period nav and the Week/Month
            toggle in the same bar. */}
        <div className="shift-search">
          <Search size={15} className="shift-search-icon" />
          <input
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search employees…"
            aria-label="Search employees by name or designation"
          />
          {query && (
            <button
              type="button"
              className="shift-search-clear"
              onClick={() => setQuery("")}
              aria-label="Clear search"
            >
              <X size={14} />
            </button>
          )}
        </div>

     <div className="shift-mnwe">
<ul className="shift-tabs">
  <li className={view === "week" ? "active" : ""} onClick={() => setView("week")}>Week</li>
  <li className={view === "month" ? "active" : ""} onClick={() => setView("month")}>Month</li>
</ul>


     </div>
  </div>




      {/* Grid */}
      {view === "week" ? (
        <div className="planner-grid">
          <div className="planner-header">
            <div className="emp-col">Employee</div>
            {weekDays.map((d, idx) => (
              <div key={idx} className={`week-day ${d.toDateString() === new Date().toDateString() ? "today" : ""}`}>
                <div className="day">{d.toLocaleDateString("en-US", { weekday: "short" })}</div>
                <div className="date">{d.getDate()}</div>
                <div className="month">{d.toLocaleString('en-US', { month: 'short' })}</div> 
              </div>
            ))}
          </div> 

          {visibleEmployees.map(emp => (
            <EmployeeRow
              key={emp.id}
              employee={emp}
              days={weekDays}
              assignments={assignments.filter(a => a.employee_id === emp.id)}
            />
          ))}

          {/* Without this the grid would render just the day headers and read
              as a loading failure rather than "nothing matched". */}
          {visibleEmployees.length === 0 && (
            <div className="planner-empty">
              {query
                ? `No employees match “${query}”.`
                : "No employees to show."}
            </div>
          )}
        </div>
      ) : (
        <MonthGrid employees={visibleEmployees} assignments={assignments} monthStart={monthStart} />
      )}
    
  </div>
  );
};

export default PlannerGrid;
